import { FormField } from "./FormField";
import { IFormControl } from "../Form";
import { TextInput } from "../text-input/TextInput";
import { Toggle } from "../toggle/Toggle";
import { useMemo } from "react";

interface IFormFieldTextInputProps {
  label?: string;
  formControl: IFormControl<boolean>
}



  export function FormFieldToggle(props: IFormFieldTextInputProps) {



    return (
      <FormField label={props.label} formControl={props.formControl}>
          <Toggle
              value={props.formControl.value}
              isDisabled={props.formControl.isDisabled}
              onToggleChanged={(val) => props.formControl.setValue(val)}
          ></Toggle>
      </FormField>

    )
  }
